import { CookieModule as o } from "@packages/common";
import { LeadFormDataService as e } from "./main30.js";
const m = {
  name: "LeadFormDataModule",
  modules: [o],
  providers: [e]
};
export {
  m as LeadFormDataModule
};
